import React, { useContext } from "react";
import { Breadcrumb } from "react-bootstrap";
import { NavLink, useParams } from "react-router-dom";

import { usePaymentReceipt } from "../../api/payment";
import { Loader } from "../../common/components/core";
import { PaymentReceiptState } from "../../types/payment";
import { BesuProjectState } from "../../types/project";
import { PageTitle } from "../../types/pageTitle";
import ProjectContext from "../project/ProjectContext";

import ReceiptDetail from "./components/ReceiptDetail";

const ReceiptDetailView = (): JSX.Element => {
    document.title = PageTitle.ReceiptDetailView;
    const { receiptId } = useParams<{ receiptId: string }>();
    const {
        data: project,
    } = useContext(ProjectContext);
    const { data: receipt, isValidating } = usePaymentReceipt(receiptId);

    return (
        <Loader isLoading={isValidating}>
            {receipt && (
                <PureReceiptDetailView
                    project={project.referenceId ? project : null}
                    receipt={receipt}
                />
            )}
        </Loader>
    );
};

type PureReceiptDetailViewProps = {
    project: BesuProjectState | null;
    receipt: PaymentReceiptState;
};

export const PureReceiptDetailView = ({
    project,
    receipt,
}: PureReceiptDetailViewProps): JSX.Element => {
    return (
        <>
            <Breadcrumb className="mb-5">
                <Breadcrumb.Item linkAs="span">
                    <NavLink to="/collection">Project List</NavLink>
                </Breadcrumb.Item>
                {project && (
                    <Breadcrumb.Item linkAs="span">
                        <NavLink
                            to={`/collection/project/${project.referenceId}`}
                        >
                            {project.name}
                        </NavLink>
                    </Breadcrumb.Item>
                )}
                <Breadcrumb.Item active className="fw-bold">
                    Transaction {receipt.amountMinor}
                </Breadcrumb.Item>
            </Breadcrumb>

            <h1 className="mb-5">Transaction {receipt.transactionRefNum}</h1>
            <ReceiptDetail receipt={receipt} />
        </>
    );
};

export default ReceiptDetailView;
